import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Label,
  Row,
} from "reactstrap";
import CopyWrapper from "components/Common/CopyWrapper";

export default function TaxInvoice({
  dataFormat
}: any) {
  const { t, i18n } = useTranslation();

  return (
    <Col md={12} lg={12}>
      <div
        className="mb-4 pt-3 pb-1 px-3 position-relative"
        style={{
          border: "1px dashed var(--vz-primary)",
          borderRadius: "4px",
        }}
      >
        <Row>
          <Col md={4} lg={4}>
            <div className="mb-3 mt-2">
              <Label htmlFor="companyName" className="form-label">
                {t("Company Name (Corporate Name)")}
              </Label>
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={dataFormat?.taxInvoice?.companyName}>
                  {`${dataFormat?.taxInvoice?.companyName || "-"}`}
                </CopyWrapper>
              </div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3 mt-2">
              <Label htmlFor="businessNumber" className="form-label">
                {t("Business Registration Number")}
              </Label>
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={dataFormat?.taxInvoice?.businessNumber}>
                  {`${dataFormat?.taxInvoice?.businessNumber || "-"}`}
                </CopyWrapper>
              </div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3 mt-2">
              <Label htmlFor="representativeName" className="form-label">
                {t("Representative Name")}
              </Label>
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={dataFormat?.taxInvoice?.representativeName}>
                  {`${dataFormat?.taxInvoice?.representativeName || "-"}`}
                </CopyWrapper>
              </div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3 mt-2">
              <Label htmlFor="businessType" className="form-label">
                {t("Business Type & Category")}
              </Label>
              <div className="cursor-pointer">
                  {`${[dataFormat?.taxInvoice?.businessType, dataFormat?.taxInvoice?.productCategory].filter(Boolean).join(" - ") || "-"}`}
              </div>
            </div>
          </Col>
          <Col md={8} lg={8}>
            <div className="mb-3 mt-2">
              <Label htmlFor="address" className="form-label">
                {t("Address")}
              </Label>
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={dataFormat?.taxInvoice?.address}>
                  {`${dataFormat?.taxInvoice?.address || "-"}`}
                </CopyWrapper>
              </div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3 mt-2">
              <Label htmlFor="emailTaxInvoice" className="form-label">
                {t("Email to Receive Tax Invoice")}
              </Label>
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={dataFormat?.taxInvoice?.emailTaxInvoice}>
                  {`${dataFormat?.taxInvoice?.emailTaxInvoice || "-"}`}
                </CopyWrapper>
              </div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3 mt-2">
              <Label htmlFor="managerName" className="form-label">
                {t("Contact Person's Name")}
              </Label>
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={dataFormat?.taxInvoice?.managerName}>
                  {`${dataFormat?.taxInvoice?.managerName || "-"}`}
                </CopyWrapper>
              </div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3 mt-2">
              <Label htmlFor="managerPhone" className="form-label">
                {t("Contact Person's Phone Number")}
              </Label>
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={dataFormat?.taxInvoice?.managerPhone}>
                  {`${dataFormat?.taxInvoice?.managerPhone || "-"}`}
                </CopyWrapper>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Col>
  );
}
